(function () {
  function formatMoney(cents, format) {
    const amount = (cents / 100).toFixed(2);
    const parts = amount.split('.');
    const withComma = `${parts[0]},${parts[1]}`;
    let value = format || '€{{amount}}';
    value = value.replace('{{amount_no_decimals}}', parts[0]);
    value = value.replace('{{amount_with_comma_separator}}', withComma);
    value = value.replace('{{amount}}', withComma);
    return value;
  }

  function initBar(bar) {
    const defaultBar = bar.parentElement ? bar.parentElement.querySelector('.announcement-bar') : null;
    const messageEl = bar.querySelector('.free-shipping-bar__message');
    const thresholdCents = parseInt(bar.dataset.thresholdCents, 10) || 0;
    const progressTemplate = bar.dataset.progressText || '';
    const successText = bar.dataset.successText || '';
    const moneyFormat = bar.dataset.moneyFormat || '';

    function updateHeight() {
      if (typeof window.setAnnouncementBarHeight === 'function') {
        requestAnimationFrame(window.setAnnouncementBarHeight);
      }
    }

    function render(totalCents, itemCount) {
      if (!itemCount) {
        bar.hidden = true;
        if (defaultBar) defaultBar.hidden = false;
        updateHeight();
        return;
      }

      bar.hidden = false;
      if (defaultBar) defaultBar.hidden = true;

      const remaining = thresholdCents - totalCents;

      if (remaining <= 0) {
        bar.classList.add('free-shipping-bar--complete');
        messageEl.textContent = successText;
      } else {
        bar.classList.remove('free-shipping-bar--complete');
        messageEl.textContent = progressTemplate.replace('[[amount]]', formatMoney(remaining, moneyFormat));
      }

      updateHeight();
    }

    function refreshFromCart() {
      fetch(`${window.routes.cart_url}.json`, { headers: { Accept: 'application/json' } })
        .then((res) => res.json())
        .then((cart) => render(cart.total_price, cart.item_count))
        .catch(() => {});
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, refreshFromCart);
    }

    refreshFromCart();
  }

  function init() {
    document.querySelectorAll('[data-free-shipping-bar]').forEach(initBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
